import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FollowupCodeInput = ({ onSubmit }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = code.trim();

    if (!trimmed) {
      setError('لطفاً کد پیگیری را وارد کنید');
      return;
    }

    onSubmit(trimmed);
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg mx-auto text-center space-y-6">
      <div className="inline-flex items-center justify-center bg-gradient-to-r from-purple-500 to-pink-500 rounded-full p-4 shadow-lg">
        <Icon name="Search" size={36} color="#ffffff" />
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
          پیگیری پیام
        </h1>
        <p className="text-sm md:text-base text-gray-600">
          کد پیگیری خود را وارد کنید
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="text-right">
          <label
            htmlFor="followup-code"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            کد پیگیری
          </label>
          <input
            id="followup-code"
            type="text"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError('');
            }}
            placeholder="مثال: ۱۲۳۴۵۶"
            dir="ltr"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-center text-lg
                       focus:ring-2 focus:ring-purple-500 focus:border-purple-500
                       outline-none transition-all"
          />
          {error && (
            <p className="text-sm text-red-500 mt-1">{error}</p>
          )}
        </div>

        <button
          type="submit"
          className="inline-flex items-center justify-center gap-2 w-full px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-xl font-semibold text-lg transition-all"
        >
          <Icon name="Search" size={18} color="#ffffff" />
          پیگیری پیام
        </button>
      </form>
    </div>
  );
};

export default FollowupCodeInput;
